export const BuilderViewConfig = {
    SUPPORT_LANGUAGE: ["en", "es", "zh", "de", "zh_HK", "zh_CN", "fr"],
    DEFAULT_LANGUAGE: "en",
    DEFAULT_REGION: "",
    PLATFORM: "PC",
    DEFAULT_THEMES: "default",
    COMMAND_MAX: 50,
    FILE_SIZE_MAX: 209715200,
    THROTTLE_DELAY: 15000,
    PC_BROWSER: {},
    MOBILE_BROWSER: {},
    BROWSERLINK: {
        chrome: "https://support.google.com/chrome/answer/96810?hl=en-GB&co=GENIE.Platform%3DDesktop&sjid=5888438474655561831-AP",
        edg: "https://support.microsoft.com/en-us/windows/internet-explorer-11-keyboard-shortcuts-bf5218a2-7626-b834-db7f-0633120e5620#ID0EDV",
        firefox: "https://support.mozilla.org/en-US/kb/font-size-and-zoom-increase-size-of-web-pages",
        opera: "https://help.opera.com/en/latest/shortcuts/#zoomKeys",
        safari: "https://support.apple.com/en-us/HT204434",
        window: "https://support.microsoft.com/en-us/windows/change-your-screen-resolution-in-windows-5effefe3-2eac-e306-0b5d-2073b765876b",
        ios: "https://support.apple.com/en-hk/guide/mac-help/mchlp2975/mac"
    }
}